import React from "react";
import { CellContext } from "@tanstack/react-table";

import { LocationNameDisplay } from "@adsk/acc-locations-components";
import SkeletonLoadingVertebra from "@adsk/alloy-react-table/es/layout/SkeletonLoadingVertebra";
import Theme from "@adsk/alloy-react-theme";
import Tooltip, { OverflowTooltip } from "@adsk/alloy-react-tooltip";

import { AssetWithCategoryAndStatus } from "../../../models";

const LocationCell = ({
  getValue,
  row,
  isLoadingLocations,
}: CellContext<AssetWithCategoryAndStatus, string> & {
  isLoadingLocations?: boolean;
}) => {
  const value = getValue();
  return isLoadingLocations ? (
    <SkeletonLoadingVertebra />
  ) : (
    <OverflowTooltip variant={Tooltip.VARIANTS.DARK}>
      {value && (
        <LocationNameDisplay
          style={
            !row.getCanSelect()
              ? { color: Theme.colors.charcoal500 }
              : undefined
          }
          locationNodeId={value}
          notFoundText=""
        />
      )}
    </OverflowTooltip>
  );
};

export default LocationCell;
